import { render, staticRenderFns } from "./PaginationShared.vue?vue&type=template&id=5e489a4e&lang=pug"
import script from "./PaginationShared.vue?vue&type=script&lang=js"
export * from "./PaginationShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports